import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { domoEmbedSections, createdDomoEmbedSection } from '../mockData/domo-embed-sections';

const DomoEmbedSectionsApi = [
  rest.get(`${API_ROOT}domo-embed-sections`, (req, res, ctx) => res(ctx.json(domoEmbedSections))),

  rest.post(`${API_ROOT}domo-embed-sections`, (req, res, ctx) => res(ctx.json(createdDomoEmbedSection))),
  rest.put(`${API_ROOT}domo-embed-sections/${domoEmbedSections.rows[0].id}`, (req, res, ctx) => res(ctx.json([domoEmbedSections.rows[0].id]))),
  rest.delete(`${API_ROOT}domo-embed-sections/${domoEmbedSections.rows[0].id}`, (req, res, ctx) => res(ctx.json(true))),
  rest.get(`${API_ROOT}domo-embed-sections/${domoEmbedSections.rows[0].id}`, (req, res, ctx) => res(ctx.json(domoEmbedSections.rows[0]))),
];
export default DomoEmbedSectionsApi;
